export const validateChildBirthdayDay = (value: string) => {
  if (!value) {
    return;
  }

  const day = parseInt(value);
  if (isNaN(day)) {
    return "Datofelt kan kun inneholde tall";
  }
  if (!(day >= 1 && day <= 31)) {
    return "Datofelt kan kun inneholde tall mellom 1 og 31";
  }
};

export const validateChildBirthdayMonth = (value: string) => {
  if (!value) {
    return;
  }

  const month = parseInt(value);
  if (isNaN(month)) {
    return "Månedsfelt kan kun inneholde tall";
  }
  if (!(month >= 1 && month <= 12)) {
    return "Månedsfelt kan kun inneholde tall mellom 1 og 12";
  }
};

export const validateChildBirthdayYear = (value: string) => {
  if (!value) {
    return;
  }

  const year = parseInt(value);
  if (isNaN(year)) {
    return "Årfeltet kan kun inneholde tall";
  }
  if (!(year >= 1900 && year <= new Date().getUTCFullYear())) {
    return "Årfeltet kan kun inneholde årstall";
  }
};
